export default __webpack_public_path__ + "static/straight-cup-blue-38efb43542fd581203697b2e57df7780.png";